import { render, staticRenderFns } from "./rejectedForm.vue?vue&type=template&id=49e75074&"
import script from "./rejectedForm.vue?vue&type=script&lang=js&"
export * from "./rejectedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports